import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-static'

const Sidebar = styled.aside`
  &.menu.column {
    padding: 50px;
    position: relative;

    .button {
      margin-top: 1em;
      display: block;
    }

    .button:first-of-type {
      color: ${props => props.theme.admin.white};
      border: 1px solid ${props => props.theme.admin.white};

      &:hover {
        color: ${props => props.theme.admin.white};
      }
    }

    .button:last-of-type {
      color: ${props => props.theme.admin.info};

      &:hover {
        color: ${props => props.theme.admin.info};
      }
    }

    @media screen and (min-width: 769px) {
      position: fixed;
      top: 0;
      left: 0;
      height: 100vh;
      width: 18em;
      min-height: 33em;

      .sidebar-buttons {
        position: absolute;
        bottom: 50px;
        left: 50px;
      }
    }
  }
`

export default function AdminSidebar({ signout, current, create, data, publish }) {
  return (
    <Sidebar className="column is-primary menu is-desktop">
      <p className="menu-label">Bagnall Hill Admin</p>
      <ul className="menu-list">
        <li className={current === 'people' ? 'current' : ''}>
          <Link to="/admin/people" activeClassName="is-active">
            People
          </Link>
        </li>
        <li className={current === 'listen' ? 'current' : ''}>
          <Link to="/admin/listen" activeClassName="is-active">
            Listen
          </Link>
          {data !== null && (
            <ul className="sub-menu">
              <li>
                <a onClick={() => create('listen')}>Add New Item</a>
              </li>
            </ul>
          )}
        </li>
      </ul>
      <div className="sidebar-buttons">
        <a className="button is-primary" onClick={publish}>
          Publish
        </a>
        <a className="button is-warning" onClick={signout}>
          Logout
        </a>
      </div>
    </Sidebar>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminSidebar.js